// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./MamahoodHeroTitle.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/static/img/IMAGES/BANNERS/homepage_banner_mobile.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * TwentyTwentysix Homepage — First-pass polish (design system direction)
 */

 :root {
  --cream: #efe4d3;
  --light: #f5f3f1;
  --white: #ffffff;
  --charcoal: #4b4450;
  --text: #433d43;
  --muted: #6b666b;

  --salmon: #de7f7d;
  --coral: #e57257;
  --mustard: #d7b85c;
  --pink: #dc8a92;
  --mint: #8eb9b2;
  --teal: #6f9f9a;
  --gold: #d8b04e;

  --radius-lg: 28px;
  --radius-md: 20px;
  --radius-sm: 14px;
  --shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  --shadow-hover: 0 14px 40px rgba(0, 0, 0, 0.12);
  --container: var(--twentytwentysix-container-max, 1280px);

  --ease-out: cubic-bezier(0.25, 0.46, 0.45, 0.94);
  --transition-fast: 180ms var(--ease-out);
  --transition-base: 220ms var(--ease-out);
  --transition-slow: 260ms var(--ease-out);
  --focus-ring: 2px solid var(--teal);
  --focus-ring-offset: 2px;

  --section-padding-y: 56px;
  --section-padding-y-sm: 48px;

  --mh-font-display: "fabulosa", serif;
}

.mh-site {
  width: 100%;
  overflow-x: hidden;
}

.mh-container {
  width: min(var(--container), calc(100% - 48px));
  margin: 0 auto;
}

.section-light {
  background: var(--light);
}

.section-cream {
  background: var(--cream);
}

.section-mustard {
  background: #d5b95a;
}

.section-charcoal {
  background: var(--charcoal);
}

.mh-eyebrow,
.mh-section-title {
  letter-spacing: 0.22em;
  font-weight: 700;
  text-transform: uppercase;
}

.mh-eyebrow {
  text-align: center;
  font-size: 0.95rem;
  margin: 0 0 12px;
}

.mh-section-title {
  font-size: 1.1rem;
  margin: 0 0 22px;
}

.mh-section-title--center {
  text-align: center;
}

.mh-section-title--light {
  color: var(--white);
}

.mh-script,
.mh-now-card__overlay h4,
.mh-program-card__overlay h4,
.mh-testimonial__content h4,
.mh-category-card__overlay h5,
.mh-collective-info h4,
.mh-about-founder__caption h4,
.mh-membership-tier h4 {
  font-family: var(--mh-font-display);
  font-weight: 400;
}

.mh-script {
  color: #de7d86;
  text-align: center;
  font-size: clamp(2rem, 4vw, 3.6rem);
  line-height: 1.08;
  max-width: 950px;
  margin: 0 auto 14px;
}

.mh-copy {
  font-size: 1.1rem;
  line-height: 1.6;
  color: var(--muted);
}

.mh-copy--center {
  text-align: center;
  max-width: 820px;
  margin: 0 auto;
}

.mh-pill {
  border: none;
  border-radius: 999px;
  padding: 13px 26px;
  cursor: pointer;
  background: var(--gold);
  color: #fff;
  font-weight: 700;
  box-shadow: var(--shadow);
  transition:
    transform var(--transition-base),
    box-shadow var(--transition-base),
    color var(--transition-fast);
}

.mh-pill:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-hover);
}

.mh-pill:active {
  transform: translateY(0);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.mh-pill:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
}

.mh-pill--small {
  padding: 10px 18px;
  font-size: 0.9rem;
}

.mh-pill--region {
  min-width: 220px;
  color: #fff;
  box-shadow: none;
  transition: transform var(--transition-base), opacity var(--transition-fast);
}

.mh-pill--region:hover {
  transform: translateY(-2px);
  opacity: 0.95;
}

.mh-pill--region:active {
  transform: translateY(0);
}

.mh-pill--region:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
}

.mh-pill--gold {
  background: var(--gold);
  color: #fff;
}

a.mh-pill,
a.mh-inline-btn,
a.mh-category-link {
  text-decoration: none;
  display: inline-block;
  text-align: center;
}

.mh-site .coral {
  background: var(--coral);
}

.mh-site .mustard {
  background: #d59d55;
}

.mh-site .pink {
  background: var(--pink);
}

.mh-site .teal {
  background: var(--teal);
}

.mh-site .salmon {
  background: var(--salmon);
}

.mh-site .mint {
  background: var(--mint);
}

.teal-text {
  color: var(--teal);
}

.mh-inline-btn {
  border: none;
  background: #ef8b6a;
  color: white;
  border-radius: 999px;
  padding: 8px 14px;
  font-size: 0.86rem;
  font-weight: 700;
  cursor: pointer;
  transition:
    transform var(--transition-fast),
    opacity var(--transition-fast),
    background-color var(--transition-fast);
}

.mh-inline-btn:hover {
  transform: translateY(-1px);
  opacity: 0.95;
  background-color: #e87a58;
}

.mh-inline-btn:active {
  transform: translateY(0);
}

.mh-inline-btn:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
}

.mh-link-row {
  display: block;
  text-align: center;
  font-weight: 700;
  padding-top: 18px;
  padding-bottom: 6px;
  color: var(--text);
  transition: color var(--transition-fast);
}

.mh-link-row:hover {
  color: var(--teal);
}

.mh-link-row:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
  border-radius: 2px;
}

.mh-link-row--light {
  color: var(--white);
}

.mh-link-row--light:hover {
  color: rgba(255, 255, 255, 0.9);
}

/* Header / nav: see components/navigation/MamahoodMarketingHeader.css */

/* Hero */
.mh-hero {
  position: relative;

  /* container behavior */
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 24px;

  min-height: 620px;

  background: #d9e6e3 url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center / cover no-repeat;

  display: flex;
  align-items: center;
}

.mh-hero__overlay {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  text-align: center;
  padding: 32px;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.08));
}

/* .mh-hero__title: see MamahoodHeroTitle.css */

/* Welcome */
.mh-welcome {
  padding: var(--section-padding-y-sm) 0 70px;
}

.mh-region-row {
  margin-top: 28px;
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
}

.mh-happening-grid {
  margin-top: 38px;
  display: grid;
  grid-template-columns: 1.3fr 0.9fr;
  gap: 28px;
  align-items: start;
}

.mh-happening-list {
  display: grid;
  gap: 14px;
}

.mh-happening-card {
  display: grid;
  grid-template-columns: 56px 1fr 48px;
  gap: 16px;
  align-items: center;
  padding: 18px 20px;
  border-radius: var(--radius-md);
  color: #fff;
  transition: transform var(--transition-base), box-shadow var(--transition-base);
}

.mh-happening-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-hover);
}

.mh-happening-card:focus-within {
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
}

.mh-happening-card__icon {
  font-size: 1.5rem;
  text-align: center;
}

.mh-happening-card__body h4 {
  margin: 0 0 4px;
  font-size: 1.15rem;
}

.mh-happening-card__body p {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.4;
}

.mh-happening-card__arrow {
  justify-self: end;
  width: 36px;
  height: 36px;
  border: 1px solid rgba(255, 255, 255, 0.75);
  border-radius: 50%;
  display: grid;
  place-items: center;
  font-size: 1.1rem;
  transition: transform var(--transition-fast);
}

.mh-happening-card:hover .mh-happening-card__arrow {
  transform: translateX(3px);
}

.mh-membership-box {
  background: #fff;
  border-radius: 30px;
  padding: 26px 24px 28px;
  box-shadow: var(--shadow);
  transition: box-shadow var(--transition-base);
}

.mh-membership-box:hover {
  box-shadow: var(--shadow-hover);
}

.mh-membership-tier {
  text-align: center;
}

.mh-membership-tier h4 {
  font-size: 2rem;
  margin: 16px 0 10px;
  line-height: 1;
}

.mh-membership-tier p {
  margin: 0 auto 16px;
  color: var(--muted);
  max-width: 320px;
  line-height: 1.5;
}

.mh-membership-divider {
  height: 1px;
  background: #ddd;
  margin: 24px 0;
}

.mh-round-logo {
  width: 78px;
  height: 78px;
  margin: 0 auto;
  border-radius: 50%;
  background: var(--mint);
  color: #fff;
  display: grid;
  place-items: center;
  font-family: var(--mh-font-display);
  font-size: 2rem;
  font-weight: 400;
}

.mh-round-logo--small {
  font-size: 1.2rem;
}

.mh-round-logo--xl {
  width: 102px;
  height: 102px;
  font-size: 1.5rem;
}

/* Stories */
.mh-stories,
.mh-now,
.mh-programs,
.mh-testimonials,
.mh-mlist,
.mh-collective,
.mh-about {
  padding: var(--section-padding-y) 0 72px;
}

.mh-story-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
}

.mh-story-card {
  background: #fff4df;
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: var(--shadow);
  transition: transform var(--transition-base), box-shadow var(--transition-base);
}

.mh-story-card:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-hover);
}

.mh-story-card:focus-within {
  box-shadow: 0 0 0 2px var(--teal);
}

.mh-story-card img {
  height: 190px;
  object-fit: cover;
  transition: transform var(--transition-slow);
}

.mh-story-card:hover img {
  transform: scale(1.03);
}

.mh-story-card__content {
  padding: 14px;
  display: flex;
  justify-content: space-between;
  gap: 14px;
  align-items: center;
}

.mh-story-card__content p {
  margin: 0;
  font-size: 0.96rem;
  line-height: 1.35;
}

/* Now */
.mh-now-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
}

.mh-now-card {
  border-radius: 24px;
  overflow: hidden;
  position: relative;
  min-height: 430px;
  box-shadow: var(--shadow);
  transition: transform var(--transition-base), box-shadow var(--transition-base);
}

.mh-now-card:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-hover);
}

.mh-now-card:focus-within {
  box-shadow: 0 0 0 2px var(--teal);
}

.mh-now-card img {
  height: 430px;
  object-fit: cover;
  transition: transform var(--transition-slow);
}

.mh-now-card:hover img {
  transform: scale(1.04);
}

.mh-now-card__overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(111, 159, 154, 0.85), rgba(0, 0, 0, 0.1));
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 26px;
}

.mh-now-card__overlay h4 {
  font-size: 3rem;
  line-height: 0.9;
  margin: 0 0 18px;
}

.mh-now-card__footer {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 14px;
}

.mh-now-card__footer p {
  margin: 0;
  font-size: 0.95rem;
  max-width: 200px;
}

/* Programs */
.mh-program-list {
  display: grid;
  gap: 18px;
}

.mh-program-card {
  --program-image-position: 50% 40%;
  --program-image-scale: 1;

  position: relative;
  min-height: 260px;
  border-radius: var(--radius-lg);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: transform var(--transition-base), box-shadow var(--transition-base);
}

.mh-program-card:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-hover);
}

.mh-program-card:focus-within {
  box-shadow: 0 0 0 2px var(--teal);
}

.mh-program-card__media {
  position: relative;
  height: 150px;
  overflow: hidden;
}

.mh-program-card__media img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: var(--program-image-position);
  transform: scale(var(--program-image-scale));
}

.mh-program-card__overlay {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 22px 28px;
  text-align: center;
  color: white;
}

.mh-program-card__overlay h4 {
  font-size: clamp(2.4rem, 4vw, 4rem);
  line-height: 0.9;
  margin: 0 0 12px;
}

.mh-program-card__overlay p {
  margin: 12px 0 0;
  font-size: 0.95rem;
  max-width: 760px;
}

/* TITLE */
.mh-program-card__overlay h4 {
  font-size: clamp(2.4rem, 4vw, 4rem);
  line-height: .9;
  margin: 0 0 12px;
}

/* SUBTITLE */
.mh-program-card__overlay p {
  margin-top: 12px;
  font-size: .95rem;


  /* lets card background color still show like your design */
  background:
    linear-gradient(
      to right,
      rgba(0, 0, 0, 0.08) 0%,
      rgba(0, 0, 0, 0.08) 38%,
      rgba(0, 0, 0, 0) 38%,
      rgba(0, 0, 0, 0) 100%
    );
}

.mh-program-card__overlay h4 {
  font-size: clamp(2.2rem, 4vw, 4.6rem);
  line-height: 0.9;
  margin: 0;
  text-shadow: 0 4px 18px rgba(0, 0, 0, 0.2);
}

.mh-program-card__overlay p {
  margin: 6px 0 0;
  font-size: 0.95rem;
  max-width: 760px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

/* Testimonials */
.mh-testimonial-list {
  display: grid;
  gap: 22px;
}

.mh-testimonial {
  --testimonial-image-position: 50% 40%;
  --testimonial-image-scale: 1;

  display: grid;
  grid-template-columns: 1fr 1.45fr;
  border-radius: 28px;
  overflow: hidden;
  background: white;
  box-shadow: var(--shadow);
  transition: transform var(--transition-base), box-shadow var(--transition-base);
}

.mh-testimonial:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-hover);
}

.mh-testimonial:focus-within {
  box-shadow: 0 0 0 2px var(--teal);
}

.mh-testimonial.reverse {
  grid-template-columns: 1.45fr 1fr;
}

.mh-testimonial.reverse .mh-testimonial__media {
  order: 2;
}

.mh-testimonial__media {
  position: relative;
  height: 100%;
  min-height: 330px;
  overflow: hidden;
}

.mh-testimonial__media img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: var(--testimonial-image-position);
  transform: scale(var(--testimonial-image-scale));
  transform-origin: center center;
  transition: transform var(--transition-slow);
}

.mh-testimonial:hover .mh-testimonial__media img {
  transform: scale(calc(var(--testimonial-image-scale) * 1.02));
}

.mh-testimonial__content {
  padding: 36px 34px;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.mh-testimonial__content.teal {
  background: var(--teal);
}

.mh-testimonial__content.mustard {
  background: #d3b357;
  color: #2f2b2f;
}

.mh-testimonial__content.coral {
  background: var(--coral);
}

.mh-testimonial__content h4 {
  font-size: clamp(2rem, 3.3vw, 3.2rem);
  line-height: 1;
  margin: 0 0 18px;
}

.mh-testimonial__content p {
  font-size: 1.1rem;
  line-height: 1.7;
  margin: 0 0 14px;
  opacity: 0.95;
}

.mh-testimonial__content strong,
.mh-testimonial__content span {
  display: block;
  font-size: 1.2rem;
  margin-top: 4px;
}

/* M List */
.mh-mlist-hero {
  position: relative;
  min-height: 260px;
}

.mh-mlist-hero img {
  height: 260px;
  object-fit: cover;
}

.mh-mlist-hero__badge {
  position: absolute;
  right: 60px;
  top: 24px;
  width: 220px;
  height: 220px;
  border: 3px dashed rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  color: white;
  display: grid;
  place-items: center;
  font-family: var(--mh-font-display);
  font-size: 2rem;
  background: rgba(151, 112, 72, 0.45);
}

.mh-center-actions {
  display: flex;
  justify-content: center;
  gap: 14px;
  flex-wrap: wrap;
  margin: 18px 0 28px;
}

.mh-category-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
}

.mh-category-card {
  background: white;
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: var(--shadow);
  transition: transform var(--transition-base), box-shadow var(--transition-base);
}

.mh-category-card:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-hover);
}

.mh-category-card:focus-within {
  box-shadow: 0 0 0 2px var(--teal);
}

.mh-category-card img {
  height: 240px;
  object-fit: cover;
  transition: transform var(--transition-slow);
}

.mh-category-card:hover img {
  transform: scale(1.03);
}

.mh-category-card__overlay {
  position: relative;
  margin-top: -120px;
  color: #fff;
  padding: 24px 20px 24px;
  min-height: 120px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.5), transparent);
}

.mh-category-card__overlay h5 {
  font-size: 3rem;
  line-height: 0.88;
  margin: 0 0 14px;
}

.mh-category-links {
  display: grid;
  gap: 10px;
  padding: 16px 14px 18px;
}

.mh-category-link {
  border: none;
  border-radius: 999px;
  padding: 12px 16px;
  background: var(--gold);
  color: white;
  font-weight: 700;
  cursor: pointer;
  transition: transform var(--transition-fast), box-shadow var(--transition-fast);
}

.mh-category-link:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow);
}

.mh-category-link:active {
  transform: translateY(0);
}

.mh-category-link:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
}

/* Collective */
.mh-collective-grid {
  display: grid;
  grid-template-columns: 1fr 1.15fr;
  gap: 30px;
  align-items: start;
}

.mh-collective-info h4 {
  font-size: clamp(2.2rem, 4vw, 4rem);
  line-height: 0.9;
  margin: 0 0 18px;
  max-width: 540px;
}

.mh-collective-info p {
  font-size: 1.05rem;
  line-height: 1.6;
  color: var(--muted);
  max-width: 430px;
}

.mh-quote-chip {
  background: var(--mint);
  color: white;
  border-radius: 24px;
  padding: 24px 26px;
  margin: 28px 0 0;
  font-size: 1.6rem;
  font-family: var(--mh-font-display);
  line-height: 1.1;
}

.mh-quote-chip span {
  display: block;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 0.95rem;
  margin-top: 10px;
}

.mh-founder-panel {
  background: var(--cream);
  border-radius: 30px;
  padding: 22px;
  box-shadow: var(--shadow);
}

.mh-founder-panel img {
  height: 360px;
  border-radius: 24px;
  object-fit: cover;
}

.mh-founder-panel__body {
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 18px;
  padding: 18px 4px 6px;
}

.mh-founder-brand {
  font-size: 2rem;
  font-family: var(--mh-font-display);
}

.mh-founder-panel__body h5 {
  font-size: 2.2rem;
  margin: 0 0 8px;
  font-family: var(--mh-font-display);
}

.mh-founder-panel__body p {
  margin: 0 0 8px;
  line-height: 1.5;
  color: var(--muted);
}

/* About */
.mh-about-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 34px;
  align-items: center;
}

.mh-about-founder img {
  height: 420px;
  border-radius: 24px;
  object-fit: cover;
}

.mh-about-founder__caption {
  text-align: center;
  color: #fff;
  margin-top: -70px;
  position: relative;
  z-index: 1;
  padding-bottom: 20px;
}

.mh-about-founder__caption h4 {
  font-size: 2.5rem;
  margin: 0 0 6px;
}

.mh-about-founder__caption p {
  margin: 0;
  color: rgba(255, 255, 255, 0.85);
}

.mh-region-row--compact {
  margin-top: 8px;
}

.mh-region-row--compact .mh-pill--region {
  min-width: 180px;
  font-size: 0.85rem;
}

.mh-about-copy {
  color: #fff;
}

.mh-about-copy p {
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.9);
  font-size: 1.05rem;
}

/* Footer */
.mh-footer {
  background: #f3f1ef;
  padding: 36px 0 50px;
}

.mh-footer__grid {
  display: grid;
  grid-template-columns: 1fr auto 1.2fr;
  gap: 30px;
  align-items: start;
}

.mh-footer__links {
  display: grid;
  gap: 10px;
  text-transform: uppercase;
  font-size: 0.84rem;
  letter-spacing: 0.08em;
  font-weight: 700;
}

.mh-footer__links a {
  color: var(--text);
  text-decoration: none;
  transition: color var(--transition-fast);
}

.mh-footer__links a:hover {
  color: var(--teal);
}

.mh-footer__links a:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
  border-radius: 2px;
}

.mh-footer__brand {
  display: grid;
  justify-items: center;
  gap: 12px;
}

.mh-newsletter h4 {
  margin: 0 0 12px;
  letter-spacing: 0.18em;
  font-size: 0.95rem;
  text-transform: uppercase;
}

.mh-newsletter__row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.mh-newsletter input {
  width: 100%;
  padding: 12px 14px;
  margin-bottom: 12px;
  border: 1px solid #cfc6bf;
  background: #fff;
}

/* Podcast page (Voyeurpreneur) — matches homepage/collective */
.mh-podcast-hero {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  align-items: center;
  padding: 48px 0 56px;
  max-width: var(--container);
  margin: 0 auto;
  width: min(var(--container), calc(100% - 48px));
}
.mh-podcast-hero__image img {
  width: 100%;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow);
  display: block;
}
.mh-podcast-hero__content h1 {
  font-family: var(--mh-font-display);
  font-weight: 400;
  font-feature-settings: var(--mh-font-display-features);
  font-size: clamp(2rem, 4vw, 3rem);
  margin: 0 0 16px;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: var(--text);
}
.mh-podcast-hero__content p {
  font-size: 1.05rem;
  line-height: 1.6;
  color: var(--muted);
  margin: 0 0 24px;
}
.mh-podcast-signup {
  padding: 40px 0 48px;
  text-align: center;
  background: var(--light);
}
.mh-podcast-signup h2 {
  font-family: var(--mh-font-display);
  font-weight: 400;
  font-feature-settings: var(--mh-font-display-features);
  font-size: clamp(1.5rem, 3vw, 2.2rem);
  margin: 0 0 8px;
  color: var(--text);
}
.mh-podcast-signup p {
  color: var(--muted);
  margin: 0 0 20px;
  font-size: 1rem;
}
.mh-podcast-form {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  max-width: 480px;
  margin: 0 auto;
}
.mh-podcast-form input {
  flex: 1 1;
  min-width: 140px;
  padding: 12px 16px;
  border: 1px solid #cfc6bf;
  border-radius: 10px;
  font-size: 1rem;
  font-family: inherit;
}
.mh-podcast-featured {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 40px;
  align-items: center;
  padding: 48px 0 56px;
  max-width: var(--container);
  margin: 0 auto;
  width: min(var(--container), calc(100% - 48px));
}
.mh-podcast-featured__image img {
  width: 100%;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow);
  display: block;
}
.mh-podcast-featured__label {
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: var(--muted);
  margin: 0 0 16px;
}
.mh-podcast-featured audio {
  width: 100%;
  margin: 0 0 20px;
  max-width: 400px;
}
.mh-podcast-featured__content a img {
  display: block;
  height: 40px;
  width: auto;
}
.mh-podcast-episodes {
  padding: 48px 0 64px;
  background: var(--light);
}
.mh-podcast-episodes h2 {
  font-family: var(--mh-font-display);
  font-weight: 400;
  font-feature-settings: var(--mh-font-display-features);
  font-size: clamp(1.75rem, 3vw, 2.5rem);
  margin: 0 0 28px;
  text-align: center;
  color: var(--text);
}
.mh-podcast-episodes__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
  max-width: var(--container);
  margin: 0 auto;
  width: min(var(--container), calc(100% - 48px));
}
.mh-podcast-episode-card {
  background: #fff;
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: var(--shadow);
  transition: transform var(--transition-base), box-shadow var(--transition-base);
}
.mh-podcast-episode-card:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-hover);
}
.mh-podcast-episode-card > a:first-child img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: block;
}
.mh-podcast-episode-card__body {
  padding: 18px;
}
.mh-podcast-episode-card__meta {
  font-size: 0.85rem;
  color: var(--muted);
  margin: 0 0 8px;
}
.mh-podcast-episode-card__body h3 {
  font-family: var(--mh-font-display);
  font-weight: 400;
  font-feature-settings: var(--mh-font-display-features);
  font-size: 1.2rem;
  margin: 0 0 10px;
  line-height: 1.25;
}
.mh-podcast-episode-card__body h3 a {
  color: var(--text);
  text-decoration: none;
}
.mh-podcast-episode-card__body h3 a:hover {
  color: var(--teal);
}
.mh-podcast-episode-card__body p {
  font-size: 0.95rem;
  line-height: 1.5;
  color: var(--muted);
  margin: 0 0 12px;
}
.mh-podcast-read-more {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--teal);
  text-decoration: none;
}
.mh-podcast-read-more:hover {
  text-decoration: underline;
}

/* Reduced motion */
@media (prefers-reduced-motion: reduce) {
  .mh-pill,
  .mh-pill--region,
  .mh-inline-btn,
  .mh-happening-card,
  .mh-happening-card__arrow,
  .mh-story-card,
  .mh-story-card img,
  .mh-now-card,
  .mh-now-card img,
  .mh-program-card,
  .mh-program-card img,
  .mh-testimonial,
  .mh-testimonial__media img,
  .mh-category-card,
  .mh-category-card img,
  .mh-category-link,
  .mh-membership-box,
  .mh-socials span,
  .mh-avatar,
  .mh-podcast-episode-card {
    transition: none;
  }

  .mh-pill:hover,
  .mh-pill--region:hover,
  .mh-inline-btn:hover,
  .mh-happening-card:hover,
  .mh-story-card:hover,
  .mh-now-card:hover,
  .mh-program-card:hover,
  .mh-testimonial:hover,
  .mh-category-card:hover,
  .mh-category-link:hover,
  .mh-socials span:hover,
  .mh-avatar:hover,
  .mh-podcast-episode-card:hover {
    transform: none;
  }

  .mh-happening-card:hover .mh-happening-card__arrow {
    transform: none;
  }

  .mh-story-card:hover img,
  .mh-now-card:hover img,
  .mh-program-card:hover img,
  .mh-category-card:hover img,
  .mh-testimonial:hover .mh-testimonial__media img {
    transform: none;
  }
}

/* Responsive */
@media (max-width: 1100px) {
  .mh-happening-grid,
  .mh-collective-grid,
  .mh-about-grid,
  .mh-footer__grid {
    grid-template-columns: 1fr;
  }

  .mh-story-grid,
  .mh-now-grid,
  .mh-category-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .mh-testimonial,
  .mh-testimonial.reverse {
    grid-template-columns: 1fr;
  }

  .mh-testimonial.reverse .mh-testimonial__media {
    order: 0;
  }
}

@media (max-width: 768px) {
  .mh-podcast-hero,
  .mh-podcast-featured {
    grid-template-columns: 1fr;
  }
  .mh-podcast-episodes__grid {
    grid-template-columns: 1fr;
  }

  .mh-hero {
    min-height: 480px;
    height: 480px;
  }

  .mh-story-grid,
  .mh-now-grid,
  .mh-category-grid,
  .mh-newsletter__row,
  .mh-founder-panel__body {
    grid-template-columns: 1fr;
  }

  .mh-category-card__overlay h5,
  .mh-now-card__overlay h4,
  .mh-testimonial__content h4,
  .mh-collective-info h4 {
    font-size: 2.2rem;
  }

  .mh-program-card__overlay h4 {
    font-size: 2rem;
  }

  .mh-mlist-hero__badge {
    width: 150px;
    height: 150px;
    right: 18px;
    top: 18px;
    font-size: 1.3rem;
  }

  .mh-container {
    width: min(100% - 28px, var(--container));
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/twentytwentysix/styles/MamahoodHomepage.css"],"names":[],"mappings":"AAAA;;EAEE;;CAGD;EACC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;;EAEhB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;;EAEf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,yCAAyC;EACzC,+CAA+C;EAC/C,yDAAyD;;EAEzD,gDAAgD;EAChD,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,mCAAmC;EACnC,wBAAwB;;EAExB,yBAAyB;EACzB,4BAA4B;;EAE5B,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;;;EAQE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB;;;gCAG8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,4EAA4E;AAC9E;;AAEA;EACE,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;;;EAGE,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf;;;2CAGyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,wEAAwE;;AAExE,SAAS;AACT;EACE,kBAAkB;;EAElB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;;EAElB,iBAAiB;;EAEjB,oFAAyG;;EAEzG,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,4FAA4F;AAC9F;;AAEA,+CAA+C;;AAE/C,YAAY;AACZ;EACE,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,+EAA+E;AACjF;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA,YAAY;AACZ;;;;;;;EAOE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,yBAAyB;EACzB,+EAA+E;AACjF;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,+EAA+E;AACjF;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kFAAkF;EAClF,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;;EAExB,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,+EAA+E;AACjF;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,8CAA8C;EAC9C,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,iBAAiB;;;EAGjB,2DAA2D;EAC3D;;;;;;;KAOG;AACL;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,SAAS;EACT,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;;EAE5B,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,+EAA+E;AACjF;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kDAAkD;EAClD,gDAAgD;EAChD,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,yBAAyB;EACzB,+EAA+E;AACjF;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,oEAAoE;AACtE;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,+EAA+E;AACjF;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA,eAAe;AACf;EACE,aAAa;EACb,iCAAiC;EACjC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,2BAA2B;EAC3B,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,WAAW;EACX,+BAA+B;EAC/B,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAEhB,sDAAsD;EACtD,iCAAiC;EACjC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAEhB,sDAAsD;EACtD,qCAAqC;EACrC,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,2BAA2B;EAC3B,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,WAAW;EACX,+BAA+B;EAC/B,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,wBAAwB;AAC1B;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAEhB,sDAAsD;EACtD,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,2BAA2B;EAC3B,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,yBAAyB;EACzB,+EAA+E;AACjF;AACA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAEhB,sDAAsD;EACtD,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE;;;;;;;;;;;;;;;;;;;;IAoBE,gBAAgB;EAClB;;EAEA;;;;;;;;;;;;;IAaE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;;IAKE,eAAe;EACjB;AACF;;AAEA,eAAe;AACf;EACE;;;;IAIE,0BAA0B;EAC5B;;EAEA;;;IAGE,qCAAqC;EACvC;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;;;;;IAKE,0BAA0B;EAC5B;;EAEA;;;;IAIE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,WAAW;IACX,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,yCAAyC;EAC3C;AACF","sourcesContent":["/*\n * TwentyTwentysix Homepage — First-pass polish (design system direction)\n */\n@import \"./MamahoodHeroTitle.css\";\n\n :root {\n  --cream: #efe4d3;\n  --light: #f5f3f1;\n  --white: #ffffff;\n  --charcoal: #4b4450;\n  --text: #433d43;\n  --muted: #6b666b;\n\n  --salmon: #de7f7d;\n  --coral: #e57257;\n  --mustard: #d7b85c;\n  --pink: #dc8a92;\n  --mint: #8eb9b2;\n  --teal: #6f9f9a;\n  --gold: #d8b04e;\n\n  --radius-lg: 28px;\n  --radius-md: 20px;\n  --radius-sm: 14px;\n  --shadow: 0 10px 30px rgba(0, 0, 0, 0.08);\n  --shadow-hover: 0 14px 40px rgba(0, 0, 0, 0.12);\n  --container: var(--twentytwentysix-container-max, 1280px);\n\n  --ease-out: cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  --transition-fast: 180ms var(--ease-out);\n  --transition-base: 220ms var(--ease-out);\n  --transition-slow: 260ms var(--ease-out);\n  --focus-ring: 2px solid var(--teal);\n  --focus-ring-offset: 2px;\n\n  --section-padding-y: 56px;\n  --section-padding-y-sm: 48px;\n\n  --mh-font-display: \"fabulosa\", serif;\n}\n\n.mh-site {\n  width: 100%;\n  overflow-x: hidden;\n}\n\n.mh-container {\n  width: min(var(--container), calc(100% - 48px));\n  margin: 0 auto;\n}\n\n.section-light {\n  background: var(--light);\n}\n\n.section-cream {\n  background: var(--cream);\n}\n\n.section-mustard {\n  background: #d5b95a;\n}\n\n.section-charcoal {\n  background: var(--charcoal);\n}\n\n.mh-eyebrow,\n.mh-section-title {\n  letter-spacing: 0.22em;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.mh-eyebrow {\n  text-align: center;\n  font-size: 0.95rem;\n  margin: 0 0 12px;\n}\n\n.mh-section-title {\n  font-size: 1.1rem;\n  margin: 0 0 22px;\n}\n\n.mh-section-title--center {\n  text-align: center;\n}\n\n.mh-section-title--light {\n  color: var(--white);\n}\n\n.mh-script,\n.mh-now-card__overlay h4,\n.mh-program-card__overlay h4,\n.mh-testimonial__content h4,\n.mh-category-card__overlay h5,\n.mh-collective-info h4,\n.mh-about-founder__caption h4,\n.mh-membership-tier h4 {\n  font-family: var(--mh-font-display);\n  font-weight: 400;\n}\n\n.mh-script {\n  color: #de7d86;\n  text-align: center;\n  font-size: clamp(2rem, 4vw, 3.6rem);\n  line-height: 1.08;\n  max-width: 950px;\n  margin: 0 auto 14px;\n}\n\n.mh-copy {\n  font-size: 1.1rem;\n  line-height: 1.6;\n  color: var(--muted);\n}\n\n.mh-copy--center {\n  text-align: center;\n  max-width: 820px;\n  margin: 0 auto;\n}\n\n.mh-pill {\n  border: none;\n  border-radius: 999px;\n  padding: 13px 26px;\n  cursor: pointer;\n  background: var(--gold);\n  color: #fff;\n  font-weight: 700;\n  box-shadow: var(--shadow);\n  transition:\n    transform var(--transition-base),\n    box-shadow var(--transition-base),\n    color var(--transition-fast);\n}\n\n.mh-pill:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-hover);\n}\n\n.mh-pill:active {\n  transform: translateY(0);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\n}\n\n.mh-pill:focus-visible {\n  outline: var(--focus-ring);\n  outline-offset: var(--focus-ring-offset);\n}\n\n.mh-pill--small {\n  padding: 10px 18px;\n  font-size: 0.9rem;\n}\n\n.mh-pill--region {\n  min-width: 220px;\n  color: #fff;\n  box-shadow: none;\n  transition: transform var(--transition-base), opacity var(--transition-fast);\n}\n\n.mh-pill--region:hover {\n  transform: translateY(-2px);\n  opacity: 0.95;\n}\n\n.mh-pill--region:active {\n  transform: translateY(0);\n}\n\n.mh-pill--region:focus-visible {\n  outline: var(--focus-ring);\n  outline-offset: var(--focus-ring-offset);\n}\n\n.mh-pill--gold {\n  background: var(--gold);\n  color: #fff;\n}\n\na.mh-pill,\na.mh-inline-btn,\na.mh-category-link {\n  text-decoration: none;\n  display: inline-block;\n  text-align: center;\n}\n\n.mh-site .coral {\n  background: var(--coral);\n}\n\n.mh-site .mustard {\n  background: #d59d55;\n}\n\n.mh-site .pink {\n  background: var(--pink);\n}\n\n.mh-site .teal {\n  background: var(--teal);\n}\n\n.mh-site .salmon {\n  background: var(--salmon);\n}\n\n.mh-site .mint {\n  background: var(--mint);\n}\n\n.teal-text {\n  color: var(--teal);\n}\n\n.mh-inline-btn {\n  border: none;\n  background: #ef8b6a;\n  color: white;\n  border-radius: 999px;\n  padding: 8px 14px;\n  font-size: 0.86rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition:\n    transform var(--transition-fast),\n    opacity var(--transition-fast),\n    background-color var(--transition-fast);\n}\n\n.mh-inline-btn:hover {\n  transform: translateY(-1px);\n  opacity: 0.95;\n  background-color: #e87a58;\n}\n\n.mh-inline-btn:active {\n  transform: translateY(0);\n}\n\n.mh-inline-btn:focus-visible {\n  outline: var(--focus-ring);\n  outline-offset: var(--focus-ring-offset);\n}\n\n.mh-link-row {\n  display: block;\n  text-align: center;\n  font-weight: 700;\n  padding-top: 18px;\n  padding-bottom: 6px;\n  color: var(--text);\n  transition: color var(--transition-fast);\n}\n\n.mh-link-row:hover {\n  color: var(--teal);\n}\n\n.mh-link-row:focus-visible {\n  outline: var(--focus-ring);\n  outline-offset: var(--focus-ring-offset);\n  border-radius: 2px;\n}\n\n.mh-link-row--light {\n  color: var(--white);\n}\n\n.mh-link-row--light:hover {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n/* Header / nav: see components/navigation/MamahoodMarketingHeader.css */\n\n/* Hero */\n.mh-hero {\n  position: relative;\n\n  /* container behavior */\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 80px 24px;\n\n  min-height: 620px;\n\n  background: #d9e6e3 url(\"/static/img/IMAGES/BANNERS/homepage_banner_mobile.png\") center / cover no-repeat;\n\n  display: flex;\n  align-items: center;\n}\n\n.mh-hero__overlay {\n  position: absolute;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  text-align: center;\n  padding: 32px;\n  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.08));\n}\n\n/* .mh-hero__title: see MamahoodHeroTitle.css */\n\n/* Welcome */\n.mh-welcome {\n  padding: var(--section-padding-y-sm) 0 70px;\n}\n\n.mh-region-row {\n  margin-top: 28px;\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.mh-happening-grid {\n  margin-top: 38px;\n  display: grid;\n  grid-template-columns: 1.3fr 0.9fr;\n  gap: 28px;\n  align-items: start;\n}\n\n.mh-happening-list {\n  display: grid;\n  gap: 14px;\n}\n\n.mh-happening-card {\n  display: grid;\n  grid-template-columns: 56px 1fr 48px;\n  gap: 16px;\n  align-items: center;\n  padding: 18px 20px;\n  border-radius: var(--radius-md);\n  color: #fff;\n  transition: transform var(--transition-base), box-shadow var(--transition-base);\n}\n\n.mh-happening-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-hover);\n}\n\n.mh-happening-card:focus-within {\n  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);\n}\n\n.mh-happening-card__icon {\n  font-size: 1.5rem;\n  text-align: center;\n}\n\n.mh-happening-card__body h4 {\n  margin: 0 0 4px;\n  font-size: 1.15rem;\n}\n\n.mh-happening-card__body p {\n  margin: 0;\n  font-size: 0.95rem;\n  line-height: 1.4;\n}\n\n.mh-happening-card__arrow {\n  justify-self: end;\n  width: 36px;\n  height: 36px;\n  border: 1px solid rgba(255, 255, 255, 0.75);\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  font-size: 1.1rem;\n  transition: transform var(--transition-fast);\n}\n\n.mh-happening-card:hover .mh-happening-card__arrow {\n  transform: translateX(3px);\n}\n\n.mh-membership-box {\n  background: #fff;\n  border-radius: 30px;\n  padding: 26px 24px 28px;\n  box-shadow: var(--shadow);\n  transition: box-shadow var(--transition-base);\n}\n\n.mh-membership-box:hover {\n  box-shadow: var(--shadow-hover);\n}\n\n.mh-membership-tier {\n  text-align: center;\n}\n\n.mh-membership-tier h4 {\n  font-size: 2rem;\n  margin: 16px 0 10px;\n  line-height: 1;\n}\n\n.mh-membership-tier p {\n  margin: 0 auto 16px;\n  color: var(--muted);\n  max-width: 320px;\n  line-height: 1.5;\n}\n\n.mh-membership-divider {\n  height: 1px;\n  background: #ddd;\n  margin: 24px 0;\n}\n\n.mh-round-logo {\n  width: 78px;\n  height: 78px;\n  margin: 0 auto;\n  border-radius: 50%;\n  background: var(--mint);\n  color: #fff;\n  display: grid;\n  place-items: center;\n  font-family: var(--mh-font-display);\n  font-size: 2rem;\n  font-weight: 400;\n}\n\n.mh-round-logo--small {\n  font-size: 1.2rem;\n}\n\n.mh-round-logo--xl {\n  width: 102px;\n  height: 102px;\n  font-size: 1.5rem;\n}\n\n/* Stories */\n.mh-stories,\n.mh-now,\n.mh-programs,\n.mh-testimonials,\n.mh-mlist,\n.mh-collective,\n.mh-about {\n  padding: var(--section-padding-y) 0 72px;\n}\n\n.mh-story-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 18px;\n}\n\n.mh-story-card {\n  background: #fff4df;\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  box-shadow: var(--shadow);\n  transition: transform var(--transition-base), box-shadow var(--transition-base);\n}\n\n.mh-story-card:hover {\n  transform: translateY(-3px);\n  box-shadow: var(--shadow-hover);\n}\n\n.mh-story-card:focus-within {\n  box-shadow: 0 0 0 2px var(--teal);\n}\n\n.mh-story-card img {\n  height: 190px;\n  object-fit: cover;\n  transition: transform var(--transition-slow);\n}\n\n.mh-story-card:hover img {\n  transform: scale(1.03);\n}\n\n.mh-story-card__content {\n  padding: 14px;\n  display: flex;\n  justify-content: space-between;\n  gap: 14px;\n  align-items: center;\n}\n\n.mh-story-card__content p {\n  margin: 0;\n  font-size: 0.96rem;\n  line-height: 1.35;\n}\n\n/* Now */\n.mh-now-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 22px;\n}\n\n.mh-now-card {\n  border-radius: 24px;\n  overflow: hidden;\n  position: relative;\n  min-height: 430px;\n  box-shadow: var(--shadow);\n  transition: transform var(--transition-base), box-shadow var(--transition-base);\n}\n\n.mh-now-card:hover {\n  transform: translateY(-3px);\n  box-shadow: var(--shadow-hover);\n}\n\n.mh-now-card:focus-within {\n  box-shadow: 0 0 0 2px var(--teal);\n}\n\n.mh-now-card img {\n  height: 430px;\n  object-fit: cover;\n  transition: transform var(--transition-slow);\n}\n\n.mh-now-card:hover img {\n  transform: scale(1.04);\n}\n\n.mh-now-card__overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(to top, rgba(111, 159, 154, 0.85), rgba(0, 0, 0, 0.1));\n  color: #fff;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  padding: 26px;\n}\n\n.mh-now-card__overlay h4 {\n  font-size: 3rem;\n  line-height: 0.9;\n  margin: 0 0 18px;\n}\n\n.mh-now-card__footer {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 14px;\n}\n\n.mh-now-card__footer p {\n  margin: 0;\n  font-size: 0.95rem;\n  max-width: 200px;\n}\n\n/* Programs */\n.mh-program-list {\n  display: grid;\n  gap: 18px;\n}\n\n.mh-program-card {\n  --program-image-position: 50% 40%;\n  --program-image-scale: 1;\n\n  position: relative;\n  min-height: 260px;\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  transition: transform var(--transition-base), box-shadow var(--transition-base);\n}\n\n.mh-program-card:hover {\n  transform: translateY(-3px);\n  box-shadow: var(--shadow-hover);\n}\n\n.mh-program-card:focus-within {\n  box-shadow: 0 0 0 2px var(--teal);\n}\n\n.mh-program-card__media {\n  position: relative;\n  height: 150px;\n  overflow: hidden;\n}\n\n.mh-program-card__media img {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n  object-position: var(--program-image-position);\n  transform: scale(var(--program-image-scale));\n}\n\n.mh-program-card__overlay {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 22px 28px;\n  text-align: center;\n  color: white;\n}\n\n.mh-program-card__overlay h4 {\n  font-size: clamp(2.4rem, 4vw, 4rem);\n  line-height: 0.9;\n  margin: 0 0 12px;\n}\n\n.mh-program-card__overlay p {\n  margin: 12px 0 0;\n  font-size: 0.95rem;\n  max-width: 760px;\n}\n\n/* TITLE */\n.mh-program-card__overlay h4 {\n  font-size: clamp(2.4rem, 4vw, 4rem);\n  line-height: .9;\n  margin: 0 0 12px;\n}\n\n/* SUBTITLE */\n.mh-program-card__overlay p {\n  margin-top: 12px;\n  font-size: .95rem;\n\n\n  /* lets card background color still show like your design */\n  background:\n    linear-gradient(\n      to right,\n      rgba(0, 0, 0, 0.08) 0%,\n      rgba(0, 0, 0, 0.08) 38%,\n      rgba(0, 0, 0, 0) 38%,\n      rgba(0, 0, 0, 0) 100%\n    );\n}\n\n.mh-program-card__overlay h4 {\n  font-size: clamp(2.2rem, 4vw, 4.6rem);\n  line-height: 0.9;\n  margin: 0;\n  text-shadow: 0 4px 18px rgba(0, 0, 0, 0.2);\n}\n\n.mh-program-card__overlay p {\n  margin: 6px 0 0;\n  font-size: 0.95rem;\n  max-width: 760px;\n  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n}\n\n/* Testimonials */\n.mh-testimonial-list {\n  display: grid;\n  gap: 22px;\n}\n\n.mh-testimonial {\n  --testimonial-image-position: 50% 40%;\n  --testimonial-image-scale: 1;\n\n  display: grid;\n  grid-template-columns: 1fr 1.45fr;\n  border-radius: 28px;\n  overflow: hidden;\n  background: white;\n  box-shadow: var(--shadow);\n  transition: transform var(--transition-base), box-shadow var(--transition-base);\n}\n\n.mh-testimonial:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-hover);\n}\n\n.mh-testimonial:focus-within {\n  box-shadow: 0 0 0 2px var(--teal);\n}\n\n.mh-testimonial.reverse {\n  grid-template-columns: 1.45fr 1fr;\n}\n\n.mh-testimonial.reverse .mh-testimonial__media {\n  order: 2;\n}\n\n.mh-testimonial__media {\n  position: relative;\n  height: 100%;\n  min-height: 330px;\n  overflow: hidden;\n}\n\n.mh-testimonial__media img {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n  object-position: var(--testimonial-image-position);\n  transform: scale(var(--testimonial-image-scale));\n  transform-origin: center center;\n  transition: transform var(--transition-slow);\n}\n\n.mh-testimonial:hover .mh-testimonial__media img {\n  transform: scale(calc(var(--testimonial-image-scale) * 1.02));\n}\n\n.mh-testimonial__content {\n  padding: 36px 34px;\n  color: white;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.mh-testimonial__content.teal {\n  background: var(--teal);\n}\n\n.mh-testimonial__content.mustard {\n  background: #d3b357;\n  color: #2f2b2f;\n}\n\n.mh-testimonial__content.coral {\n  background: var(--coral);\n}\n\n.mh-testimonial__content h4 {\n  font-size: clamp(2rem, 3.3vw, 3.2rem);\n  line-height: 1;\n  margin: 0 0 18px;\n}\n\n.mh-testimonial__content p {\n  font-size: 1.1rem;\n  line-height: 1.7;\n  margin: 0 0 14px;\n  opacity: 0.95;\n}\n\n.mh-testimonial__content strong,\n.mh-testimonial__content span {\n  display: block;\n  font-size: 1.2rem;\n  margin-top: 4px;\n}\n\n/* M List */\n.mh-mlist-hero {\n  position: relative;\n  min-height: 260px;\n}\n\n.mh-mlist-hero img {\n  height: 260px;\n  object-fit: cover;\n}\n\n.mh-mlist-hero__badge {\n  position: absolute;\n  right: 60px;\n  top: 24px;\n  width: 220px;\n  height: 220px;\n  border: 3px dashed rgba(255, 255, 255, 0.8);\n  border-radius: 50%;\n  color: white;\n  display: grid;\n  place-items: center;\n  font-family: var(--mh-font-display);\n  font-size: 2rem;\n  background: rgba(151, 112, 72, 0.45);\n}\n\n.mh-center-actions {\n  display: flex;\n  justify-content: center;\n  gap: 14px;\n  flex-wrap: wrap;\n  margin: 18px 0 28px;\n}\n\n.mh-category-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 22px;\n}\n\n.mh-category-card {\n  background: white;\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  box-shadow: var(--shadow);\n  transition: transform var(--transition-base), box-shadow var(--transition-base);\n}\n\n.mh-category-card:hover {\n  transform: translateY(-3px);\n  box-shadow: var(--shadow-hover);\n}\n\n.mh-category-card:focus-within {\n  box-shadow: 0 0 0 2px var(--teal);\n}\n\n.mh-category-card img {\n  height: 240px;\n  object-fit: cover;\n  transition: transform var(--transition-slow);\n}\n\n.mh-category-card:hover img {\n  transform: scale(1.03);\n}\n\n.mh-category-card__overlay {\n  position: relative;\n  margin-top: -120px;\n  color: #fff;\n  padding: 24px 20px 24px;\n  min-height: 120px;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.5), transparent);\n}\n\n.mh-category-card__overlay h5 {\n  font-size: 3rem;\n  line-height: 0.88;\n  margin: 0 0 14px;\n}\n\n.mh-category-links {\n  display: grid;\n  gap: 10px;\n  padding: 16px 14px 18px;\n}\n\n.mh-category-link {\n  border: none;\n  border-radius: 999px;\n  padding: 12px 16px;\n  background: var(--gold);\n  color: white;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform var(--transition-fast), box-shadow var(--transition-fast);\n}\n\n.mh-category-link:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow);\n}\n\n.mh-category-link:active {\n  transform: translateY(0);\n}\n\n.mh-category-link:focus-visible {\n  outline: var(--focus-ring);\n  outline-offset: var(--focus-ring-offset);\n}\n\n/* Collective */\n.mh-collective-grid {\n  display: grid;\n  grid-template-columns: 1fr 1.15fr;\n  gap: 30px;\n  align-items: start;\n}\n\n.mh-collective-info h4 {\n  font-size: clamp(2.2rem, 4vw, 4rem);\n  line-height: 0.9;\n  margin: 0 0 18px;\n  max-width: 540px;\n}\n\n.mh-collective-info p {\n  font-size: 1.05rem;\n  line-height: 1.6;\n  color: var(--muted);\n  max-width: 430px;\n}\n\n.mh-quote-chip {\n  background: var(--mint);\n  color: white;\n  border-radius: 24px;\n  padding: 24px 26px;\n  margin: 28px 0 0;\n  font-size: 1.6rem;\n  font-family: var(--mh-font-display);\n  line-height: 1.1;\n}\n\n.mh-quote-chip span {\n  display: block;\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 0.95rem;\n  margin-top: 10px;\n}\n\n.mh-founder-panel {\n  background: var(--cream);\n  border-radius: 30px;\n  padding: 22px;\n  box-shadow: var(--shadow);\n}\n\n.mh-founder-panel img {\n  height: 360px;\n  border-radius: 24px;\n  object-fit: cover;\n}\n\n.mh-founder-panel__body {\n  display: grid;\n  grid-template-columns: 140px 1fr;\n  gap: 18px;\n  padding: 18px 4px 6px;\n}\n\n.mh-founder-brand {\n  font-size: 2rem;\n  font-family: var(--mh-font-display);\n}\n\n.mh-founder-panel__body h5 {\n  font-size: 2.2rem;\n  margin: 0 0 8px;\n  font-family: var(--mh-font-display);\n}\n\n.mh-founder-panel__body p {\n  margin: 0 0 8px;\n  line-height: 1.5;\n  color: var(--muted);\n}\n\n/* About */\n.mh-about-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 34px;\n  align-items: center;\n}\n\n.mh-about-founder img {\n  height: 420px;\n  border-radius: 24px;\n  object-fit: cover;\n}\n\n.mh-about-founder__caption {\n  text-align: center;\n  color: #fff;\n  margin-top: -70px;\n  position: relative;\n  z-index: 1;\n  padding-bottom: 20px;\n}\n\n.mh-about-founder__caption h4 {\n  font-size: 2.5rem;\n  margin: 0 0 6px;\n}\n\n.mh-about-founder__caption p {\n  margin: 0;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.mh-region-row--compact {\n  margin-top: 8px;\n}\n\n.mh-region-row--compact .mh-pill--region {\n  min-width: 180px;\n  font-size: 0.85rem;\n}\n\n.mh-about-copy {\n  color: #fff;\n}\n\n.mh-about-copy p {\n  line-height: 1.7;\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 1.05rem;\n}\n\n/* Footer */\n.mh-footer {\n  background: #f3f1ef;\n  padding: 36px 0 50px;\n}\n\n.mh-footer__grid {\n  display: grid;\n  grid-template-columns: 1fr auto 1.2fr;\n  gap: 30px;\n  align-items: start;\n}\n\n.mh-footer__links {\n  display: grid;\n  gap: 10px;\n  text-transform: uppercase;\n  font-size: 0.84rem;\n  letter-spacing: 0.08em;\n  font-weight: 700;\n}\n\n.mh-footer__links a {\n  color: var(--text);\n  text-decoration: none;\n  transition: color var(--transition-fast);\n}\n\n.mh-footer__links a:hover {\n  color: var(--teal);\n}\n\n.mh-footer__links a:focus-visible {\n  outline: var(--focus-ring);\n  outline-offset: var(--focus-ring-offset);\n  border-radius: 2px;\n}\n\n.mh-footer__brand {\n  display: grid;\n  justify-items: center;\n  gap: 12px;\n}\n\n.mh-newsletter h4 {\n  margin: 0 0 12px;\n  letter-spacing: 0.18em;\n  font-size: 0.95rem;\n  text-transform: uppercase;\n}\n\n.mh-newsletter__row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.mh-newsletter input {\n  width: 100%;\n  padding: 12px 14px;\n  margin-bottom: 12px;\n  border: 1px solid #cfc6bf;\n  background: #fff;\n}\n\n/* Podcast page (Voyeurpreneur) — matches homepage/collective */\n.mh-podcast-hero {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 48px;\n  align-items: center;\n  padding: 48px 0 56px;\n  max-width: var(--container);\n  margin: 0 auto;\n  width: min(var(--container), calc(100% - 48px));\n}\n.mh-podcast-hero__image img {\n  width: 100%;\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow);\n  display: block;\n}\n.mh-podcast-hero__content h1 {\n  font-family: var(--mh-font-display);\n  font-weight: 400;\n  -webkit-font-feature-settings: var(--mh-font-display-features);\n  font-feature-settings: var(--mh-font-display-features);\n  font-size: clamp(2rem, 4vw, 3rem);\n  margin: 0 0 16px;\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n  color: var(--text);\n}\n.mh-podcast-hero__content p {\n  font-size: 1.05rem;\n  line-height: 1.6;\n  color: var(--muted);\n  margin: 0 0 24px;\n}\n.mh-podcast-signup {\n  padding: 40px 0 48px;\n  text-align: center;\n  background: var(--light);\n}\n.mh-podcast-signup h2 {\n  font-family: var(--mh-font-display);\n  font-weight: 400;\n  -webkit-font-feature-settings: var(--mh-font-display-features);\n  font-feature-settings: var(--mh-font-display-features);\n  font-size: clamp(1.5rem, 3vw, 2.2rem);\n  margin: 0 0 8px;\n  color: var(--text);\n}\n.mh-podcast-signup p {\n  color: var(--muted);\n  margin: 0 0 20px;\n  font-size: 1rem;\n}\n.mh-podcast-form {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 12px;\n  max-width: 480px;\n  margin: 0 auto;\n}\n.mh-podcast-form input {\n  flex: 1;\n  min-width: 140px;\n  padding: 12px 16px;\n  border: 1px solid #cfc6bf;\n  border-radius: 10px;\n  font-size: 1rem;\n  font-family: inherit;\n}\n.mh-podcast-featured {\n  display: grid;\n  grid-template-columns: 1fr 1.2fr;\n  gap: 40px;\n  align-items: center;\n  padding: 48px 0 56px;\n  max-width: var(--container);\n  margin: 0 auto;\n  width: min(var(--container), calc(100% - 48px));\n}\n.mh-podcast-featured__image img {\n  width: 100%;\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow);\n  display: block;\n}\n.mh-podcast-featured__label {\n  font-size: 0.9rem;\n  font-weight: 700;\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n  color: var(--muted);\n  margin: 0 0 16px;\n}\n.mh-podcast-featured audio {\n  width: 100%;\n  margin: 0 0 20px;\n  max-width: 400px;\n}\n.mh-podcast-featured__content a img {\n  display: block;\n  height: 40px;\n  width: auto;\n}\n.mh-podcast-episodes {\n  padding: 48px 0 64px;\n  background: var(--light);\n}\n.mh-podcast-episodes h2 {\n  font-family: var(--mh-font-display);\n  font-weight: 400;\n  -webkit-font-feature-settings: var(--mh-font-display-features);\n  font-feature-settings: var(--mh-font-display-features);\n  font-size: clamp(1.75rem, 3vw, 2.5rem);\n  margin: 0 0 28px;\n  text-align: center;\n  color: var(--text);\n}\n.mh-podcast-episodes__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 24px;\n  max-width: var(--container);\n  margin: 0 auto;\n  width: min(var(--container), calc(100% - 48px));\n}\n.mh-podcast-episode-card {\n  background: #fff;\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  box-shadow: var(--shadow);\n  transition: transform var(--transition-base), box-shadow var(--transition-base);\n}\n.mh-podcast-episode-card:hover {\n  transform: translateY(-3px);\n  box-shadow: var(--shadow-hover);\n}\n.mh-podcast-episode-card > a:first-child img {\n  width: 100%;\n  height: 200px;\n  object-fit: cover;\n  display: block;\n}\n.mh-podcast-episode-card__body {\n  padding: 18px;\n}\n.mh-podcast-episode-card__meta {\n  font-size: 0.85rem;\n  color: var(--muted);\n  margin: 0 0 8px;\n}\n.mh-podcast-episode-card__body h3 {\n  font-family: var(--mh-font-display);\n  font-weight: 400;\n  -webkit-font-feature-settings: var(--mh-font-display-features);\n  font-feature-settings: var(--mh-font-display-features);\n  font-size: 1.2rem;\n  margin: 0 0 10px;\n  line-height: 1.25;\n}\n.mh-podcast-episode-card__body h3 a {\n  color: var(--text);\n  text-decoration: none;\n}\n.mh-podcast-episode-card__body h3 a:hover {\n  color: var(--teal);\n}\n.mh-podcast-episode-card__body p {\n  font-size: 0.95rem;\n  line-height: 1.5;\n  color: var(--muted);\n  margin: 0 0 12px;\n}\n.mh-podcast-read-more {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--teal);\n  text-decoration: none;\n}\n.mh-podcast-read-more:hover {\n  text-decoration: underline;\n}\n\n/* Reduced motion */\n@media (prefers-reduced-motion: reduce) {\n  .mh-pill,\n  .mh-pill--region,\n  .mh-inline-btn,\n  .mh-happening-card,\n  .mh-happening-card__arrow,\n  .mh-story-card,\n  .mh-story-card img,\n  .mh-now-card,\n  .mh-now-card img,\n  .mh-program-card,\n  .mh-program-card img,\n  .mh-testimonial,\n  .mh-testimonial__media img,\n  .mh-category-card,\n  .mh-category-card img,\n  .mh-category-link,\n  .mh-membership-box,\n  .mh-socials span,\n  .mh-avatar,\n  .mh-podcast-episode-card {\n    transition: none;\n  }\n\n  .mh-pill:hover,\n  .mh-pill--region:hover,\n  .mh-inline-btn:hover,\n  .mh-happening-card:hover,\n  .mh-story-card:hover,\n  .mh-now-card:hover,\n  .mh-program-card:hover,\n  .mh-testimonial:hover,\n  .mh-category-card:hover,\n  .mh-category-link:hover,\n  .mh-socials span:hover,\n  .mh-avatar:hover,\n  .mh-podcast-episode-card:hover {\n    transform: none;\n  }\n\n  .mh-happening-card:hover .mh-happening-card__arrow {\n    transform: none;\n  }\n\n  .mh-story-card:hover img,\n  .mh-now-card:hover img,\n  .mh-program-card:hover img,\n  .mh-category-card:hover img,\n  .mh-testimonial:hover .mh-testimonial__media img {\n    transform: none;\n  }\n}\n\n/* Responsive */\n@media (max-width: 1100px) {\n  .mh-happening-grid,\n  .mh-collective-grid,\n  .mh-about-grid,\n  .mh-footer__grid {\n    grid-template-columns: 1fr;\n  }\n\n  .mh-story-grid,\n  .mh-now-grid,\n  .mh-category-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .mh-testimonial,\n  .mh-testimonial.reverse {\n    grid-template-columns: 1fr;\n  }\n\n  .mh-testimonial.reverse .mh-testimonial__media {\n    order: 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .mh-podcast-hero,\n  .mh-podcast-featured {\n    grid-template-columns: 1fr;\n  }\n  .mh-podcast-episodes__grid {\n    grid-template-columns: 1fr;\n  }\n\n  .mh-hero {\n    min-height: 480px;\n    height: 480px;\n  }\n\n  .mh-story-grid,\n  .mh-now-grid,\n  .mh-category-grid,\n  .mh-newsletter__row,\n  .mh-founder-panel__body {\n    grid-template-columns: 1fr;\n  }\n\n  .mh-category-card__overlay h5,\n  .mh-now-card__overlay h4,\n  .mh-testimonial__content h4,\n  .mh-collective-info h4 {\n    font-size: 2.2rem;\n  }\n\n  .mh-program-card__overlay h4 {\n    font-size: 2rem;\n  }\n\n  .mh-mlist-hero__badge {\n    width: 150px;\n    height: 150px;\n    right: 18px;\n    top: 18px;\n    font-size: 1.3rem;\n  }\n\n  .mh-container {\n    width: min(100% - 28px, var(--container));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
